import * as React from "react";
import "./Loader.scss";
import backdrop from "../../assets/no-data-backdrop.png";

interface NoDataProps {
    title?: string;
    description?: string;
}

const NoData: React.FunctionComponent<NoDataProps> = (props: NoDataProps) => {
    const { title, description } = props;

    return (
        <div className="data-placeholders">
            <img src={backdrop} alt="" />
            <h3 className="spaced-bottom">{title}</h3>
            <span>{description}</span>
        </div>
    );
};

export default NoData;